import { FormOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography, Tooltip } from 'antd';
import parse, { Element, HTMLReactParserOptions } from 'html-react-parser';
import moment from 'moment';
import React from 'react';

import { CandidateCommentaryCollection, UserCollection } from '../../types';
import styles from './ApplicantHistory.module.css';

interface ApplicantAnnotationTimelineProps {
  annotationType?: CandidateCommentaryCollection['type'];
  annotation: string;
  fromStage?: string;
  opportunityTitle?: string;
  recruiterName: string;
  createdDate: string;
  users?: UserCollection[];
}

const ApplicantAnnotationTimeline = ({
  annotation,
  annotationType = 'NEUTRAL',
  fromStage,
  opportunityTitle,
  recruiterName,
  createdDate,
  users,
}: ApplicantAnnotationTimelineProps) => {
  const iconColor =
    annotationType === 'NEGATIVE'
      ? styles.errorColor
      : annotationType === 'POSITIVE'
      ? styles.sucessColor
      : styles.neutralColor;

  const processedAnnotation = React.useMemo(() => {
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (
          domNode instanceof Element &&
          domNode.attribs &&
          domNode.attribs.class &&
          domNode.attribs.class.includes('mention') &&
          domNode.attribs['data-id']
        ) {
          const userId = Number(domNode.attribs['data-id'] || '');
          const user = users?.find(({ id }) => id === userId);

          if (user) {
            return (
              <Tooltip title={user.email}>
                <span data-id={user.id} className="mention">
                  @{user.full_name}
                </span>
              </Tooltip>
            );
          }
          return <></>;
        }
      },
    };

    return parse(annotation, options);
  }, [annotation, users]);

  return (
    <Timeline.Item dot={<FormOutlined className={iconColor} />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text strong>{recruiterName}</Typography.Text> criou um comentário{' '}
          {annotationType === 'NEGATIVE' && <Typography.Text strong>negativo</Typography.Text>}
          {annotationType === 'POSITIVE' && <Typography.Text strong>positivo</Typography.Text>}
          {annotationType === 'NEUTRAL' && <Typography.Text strong>neutro</Typography.Text>}{' '}
          {fromStage && opportunityTitle && (
            <>
              na etapa <Typography.Text strong>{fromStage}</Typography.Text> na vaga{' '}
              <Typography.Text strong>{opportunityTitle}</Typography.Text>
            </>
          )}
        </Typography.Paragraph>
        <Divider />
        <div className={styles.description}>{processedAnnotation}</div>
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantAnnotationTimeline;
